import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_CONTENT, mergeContent } from "@/lib/defaultContent";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentContext = createContext({ content: DEFAULT_CONTENT, loading: true });

export function SiteContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API}/site-content`)
      .then((r) => {
        const remote = r?.data?.content;
        if (remote) setContent(mergeContent(DEFAULT_CONTENT, remote));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <SiteContentContext.Provider value={{ content, loading }}>
      {children}
    </SiteContentContext.Provider>
  );
}

export function useSiteContent() {
  return useContext(SiteContentContext).content;
}
